import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import * as S from './Footer.styled';
import QueryStringNavigate from '../QueryStringNavigate';

const BlockLinks = ({ linkList, label }) => {
  const { t } = useTranslation(['footer'], { useSuspense: false });
  return (
    <S.FooterItemsBlock>
      <S.FooterItemsTitle>{t(label)}</S.FooterItemsTitle>
      <S.FooterItems>
        {linkList.map(
          (item) =>
            item.href && (
              <QueryStringNavigate
                key={item.label}
                id={item.label}
                path={item.href}
              >
                {' '}
                {t(item.label)}
              </QueryStringNavigate>
            ),
        )}
      </S.FooterItems>
    </S.FooterItemsBlock>
  );
};

BlockLinks.displayName = 'BlockLinks';
export default BlockLinks;
